import { Preorder } from "../../../../../types/bookings";

export type GroupedItem = {
  type: string;
  subType: string;
  time: string;
  name: string;
  totalQuantity: number;
  totalCost: number;
  price: number;
  customers: Array<{ name: string; quantity: number; seat?: string }>;
  description?: string;
  menuId?: string;
  isHeading?: boolean;
  preOrderIds: string[];
};

export type GroupedPreOrders = Record<string, GroupedItem[]>;

export type GroupedPreOrdersForCards = Record<string, Preorder[]>;

const COLOUR_NAMES = [
  "pink",
  "green",
  "blue",
  "yellow",
  "purple",
  "orange",
  "teal",
  "red",
  "indigo",
  "cyan",
  "lime",
  "amber",
  "emerald",
  "violet",
  "fuchsia",
  "rose",
  "sky",
  "slate",
  "stone",
  "zinc"
];

const generateColourPalette = (
  colours: string[]
): Array<{ bg: string; border: string }> => {
  const palette: Array<{ bg: string; border: string }> = [];

  colours.forEach((colour) => {
    palette.push({
      bg: `bg-${colour}-50 dark:bg-muted`,
      border: `border-${colour}-200 dark:border-${colour}-400`
    });
  });

  colours.forEach((colour) => {
    palette.push({
      bg: `bg-${colour}-100 dark:bg-muted`,
      border: `border-${colour}-300 dark:border-${colour}-500`
    });
  });

  return palette;
};

export const GUEST_COLOR_PALETTE = generateColourPalette(COLOUR_NAMES);

export const normaliseGuestName = (s: string): string =>
  s.trim().toLowerCase().replace(/\s+/g, " ");
